import { useCallback } from 'react'
import { search } from 'jmespath'
import { successNotification } from '@sceneio/cms-notifications'
import { useInternalGraphql } from '../useInternalGraphql'
import { CallbacksType } from '../types/callbacksTypes'
import { GqlErrorsType } from '../types/gqlErrorsTypes'

export function useContentCreateVariant(): (
  id: string,
  callbacks?: CallbacksType,
  options?: {
    showNotification?: boolean
  },
) => Promise<{
  data: any | null | undefined
  errors: GqlErrorsType
}> {
  const { sendRequest: createContentVariant } = useInternalGraphql({
    query: 'ContentCreateVariantMutationDocument',
    runOnInit: false,
  })

  return useCallback(
    async (
      id: string,
      { onSuccess }: CallbacksType = {},
      { showNotification = true } = {},
    ) => {
      let result: { data: any; errors: GqlErrorsType } = {
        data: null,
        errors: [],
      }

      try {
        const { data: gqlData, errors: gqlErrors } =
          (await createContentVariant({ variables: { id } })) || {}
        if (gqlErrors && gqlErrors.length > 0) {
          throw Error(gqlErrors[0].message)
        }
        const responseData = search(gqlData, 'createContentVariant')

        if (showNotification) {
          successNotification({ content: 'Content variant created' })
        }

        if (onSuccess) {
          onSuccess(gqlData)
        }

        result = {
          data: responseData,
          errors: [],
        }
      } catch (errs) {
        console.warn('[createContentVariant]', errs)
        result = {
          data: null,
          errors: errs as GqlErrorsType,
        }
      }

      return result
    },
    [createContentVariant],
  )
}
